import React from 'react';
import { Link } from 'react-router-dom';

// Vendor Components
import { Row, Col, Container } from 'react-bootstrap';

// import SocialLinks from './components/SocialLinks/index.js';
// Components
import background404 from '../../assets/imgs/portrait.jpg';

import './style.scss';
const bgPath = background404;

const NotFound = () => {
  return (
    <Container className="error__container">
      <Row>
        <Col>
          <div className="glitch__container">
            <div className="overlay" style={{ backgroundImage: `url(${bgPath})` }}>
              404
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <h2 className="error__message">We couldn't find what you were looking for.</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <span className="btn m-5">
            <Link className="btn link--white" to="/">
              Go to Homepage
            </Link>
          </span>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;
